/**
 * NgageCode Web (code.ngagesuite.com). There is exactly one place to work: the signed-in person's
 * workspace on the NgageCode server. No folders to open, no server to pick; the gateway pins every
 * request to that workspace whatever directory the page names.
 */
export const NGC_WEB = import.meta.env.VITE_NGC_WEB === "1"

/** Used until the workspace has told us its folder. The gateway maps any name to the person's one workspace. */
export const NGC_WEB_FALLBACK = "/cloud-workspace"

/**
 * The folder the app uses for the workspace everywhere (routes, side panel, chats). It is the workspace's own
 * folder on the server, learned at sign-in, so that the project, its chats and their links all agree.
 */
export function ngcWorkspace(): string {
  return (window as unknown as { __ngcWorkspaceDir?: string }).__ngcWorkspaceDir || NGC_WEB_FALLBACK
}

/** Start the next message on one of your apps. Works from anywhere: the chat page listens for it. */
export function ngcChangeApp(app: { name: string; folder: string; text?: string }) {
  window.dispatchEvent(new CustomEvent("ngc-web:change-app", { detail: app }))
}
